<template>
  <div>
          <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                  <b-spinner></b-spinner>
                  <br><br>
                  <strong>Loading</strong>
              </b-col>
          </b-row>
          <b-form @submit.prevent="confirm">


          <b-row class="m-0 mb-3" v-if="typeof project.title !='undefined'">
            <b-col class="p-0 pr-1">
              <b-row class="m-0">
                <b-col cols="1" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
                    <font-awesome-icon icon="map-marker" class="h2 mb-0" />
                </b-col>
                <b-col class="p-2 bg-white d-flex align-items-center border">
                    <div>
                    <h6 class="mb-0 text-muted">Project</h6>
                    <h6 class="mb-0">
                        <strong>{{project.title}}</strong>
                    </h6>
                    </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="p-0 px-1" cols="3">
              <b-row class="m-0">
                <b-col cols="2" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
                    <font-awesome-icon icon="calendar" class="h2 mb-0" />
                </b-col>
                <b-col class="p-2 bg-white d-flex align-items-center border">
                    <div>
                    <h6 class="mb-0 text-muted">Date</h6>
                    <h6 class="mb-0">
                        <strong>{{$route.params.date_from}} - {{$route.params.date_to}}</strong>
                    </h6>
                    </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="p-0 pl-1" cols="3">
              <b-row class="m-0">
                <b-col cols="2" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
                    <font-awesome-icon icon="check-circle" class="h2 mb-0" />
                </b-col>
                <b-col class="p-2 bg-white d-flex align-items-center border">
                    <div>
                    <h6 class="mb-0 text-muted">Total</h6>
                    <h6 class="mb-0">
                        <strong><number-format-component :input_value="Number(total)"/></strong>
                    </h6>
                    </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
              <table class="table table-bordered mb-0 mt-3">
                  <thead class="bg-light text-dark">
                  <tr>
                      <th scope="col" rowspan="2">Employee</th>
                      <!-- DYNAMIC DATES -->
                      <th
                              v-for="date in payroll_dates"
                              :key="date"
                              colspan="3"
                              class="text-center"
                              style="white-space: pre-line;"
                      >
                          {{ formatDate(date) }}
                      </th>
                      <th scope="col" class="text-center" colspan="2">TOTAL HOURS</th>
                      <th scope="col" rowspan="2" class="text-center">TOTAL DAYS</th>
                      <th scope="col" rowspan="2" class="text-center">TOTAL AMOUNT</th>
                      <th scope="col" rowspan="2" class="text-center">SIGNATURE</th>
                  </tr>
                  <tr>
                      <template v-for="date in payroll_dates">

                          <th
                                  :key="date + '-reg'"
                                  class="text-center"
                          >
                              REG
                          </th>

                          <th
                                  :key="date + '-ot'"
                                  class="text-center"
                          >
                              OT
                          </th>

                          <th
                                  :key="date + '-amount'"
                                  class="text-center"
                          >
                              AMT
                          </th>

                      </template>
                      <th scope="col" class="text-center">Regular</th>
                      <th scope="col" class="text-center">OT</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(payroll_detail, index) in form.payroll_details">
                      <td class="text-nowrap">
                          {{payroll_detail.full_name}}
                      </td>
                      <!-- DAILY LOGS -->
                      <template v-for="date in payroll_dates">

                          <!-- REG -->
                          <td
                                  :key="date + '-regular-' + index"
                                  class="text-center"
                          >
                              {{
                              getLog(payroll_detail.logs, date)
                              ? Number(
                              getLog(payroll_detail.logs, date).regular_hours
                              ).toFixed(1)
                              : '0.0'
                              }}

                          </td>

                          <!-- OT -->
                          <td
                                  :key="date + '-ot-' + index"
                                  class="text-center"
                          >

                              {{
                              getLog(payroll_detail.logs, date)
                              ? Number(
                              getLog(payroll_detail.logs, date).ot_hours
                              ).toFixed(1)
                              : '0.0'
                              }}

                          </td>

                          <!-- AMOUNT -->
                          <td
                                  :key="date + '-amount-' + index"
                                  class="text-right"
                          >

                              <number-format-component
                                      :input_value="
                          getLog(payroll_detail.logs, date)
                          ? Number(
                              getLog(payroll_detail.logs, date).total
                            )
                          : 0
                        "
                                      :currency="false"
                              />

                          </td>

                      </template>
                      <td class="text-center">
                          <number-format-component :input_value="Number(payroll_detail.total_regular_hours)" :currency="false" :decimal=1 />
                      </td>
                      <td class="text-center">
                          <number-format-component :input_value="Number(payroll_detail.total_ot_hours)" :currency="false" :decimal=1 />
                      </td>
                      <td class="text-center">
                          <a href="#" @click="showLogDetails(payroll_detail.manpower_id)">
                              <number-format-component :input_value="Number(payroll_detail.total_days)" :currency="false" :decimal=0 />
                          </a>
                      </td>
                      <td class="text-right">
                          <number-format-component :input_value="Number(payroll_detail.initial_payout)" :currency="false"/>
                      </td>
                      <td class="text-center">

                      </td>
                  </tr>
                  </tbody>
                  <tfoot class="bg-light text-dark">
                  <tr>
                      <th scope="col" class="text-right" :colspan="(payroll_dates.length * 3) + 4">GRAND TOTAL</th>
                      <th scope="col" class="text-right"><number-format-component :input_value="Number(grand_initial_payout)"/></th>
                      <th scope="col" class="text-right">&nbsp;</th>
                  </tr>
                  </tfoot>
              </table>

        </b-form>


    <b-modal v-model="daily_logs_modal" centered size="xl" body-class="p-0" :hide-footer="true" :hide-header="true">
      <div class="card bg-light mb-0" v-if="typeof log_details.manpower!='undefined'">
        <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h6 class="mb-0"><font-awesome-icon icon="list" /> Log Details</h6>
        </div>
        <div class="card-body bg-white position-relative">
          <b-row class="m-0">
            <b-col cols="1" class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="user" class="h2 mb-0" />
            </b-col>
            <b-col class="p-2 bg-white d-flex align-items-center border">
              <div>
                <h6 class="mb-0 text-muted">Manpower</h6>
                <h6 class="mb-0">
                  <strong>{{log_details.manpower.full_name}}</strong>
                </h6>
              </div>
            </b-col>
          </b-row>
          <table class="table table-bordered mb-0 mt-3">
            <thead class="bg-light text-dark">
            <tr>
              <th scope="col" rowspan="2">Date</th>
              <th scope="col" rowspan="2" v-if="form.payroll_type==1">Item</th>
              <th scope="col" rowspan="2">Job Description</th>
              <th scope="col" rowspan="2">Rate</th>
              <th scope="col" class="text-center" colspan="3">Hours</th>
              <th scope="col" rowspan="2" class="text-center">Total Payout</th>
            </tr>
            <tr>
              <th scope="col" class="text-center">Regular</th>
                <th scope="col" class="text-center">OT</th>
                <th scope="col" class="text-center">ND</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(log_detail, index) in log_details.log_details">
              <td>{{log_detail.transaction_date}}</td>
              <td v-if="form.payroll_type==1">{{log_detail.project_location_structure_item}}</td>
              <td>{{log_detail.job_description}}</td>
              <td class="text-right"><number-format-component :input_value="Number(log_detail.daily_rate)" :decimal="2" /></td>
              <td class="text-right"><number-format-component :input_value="Number(log_detail.regular_hours)" :currency="false" :decimal=1 /></td>
              <td class="text-right"><number-format-component :input_value="Number(log_detail.ot_hours)" :currency="false" :decimal=1 /></td>
              <td class="text-right"><number-format-component :input_value="Number(log_detail.nd_hours)" :currency="false" :decimal=1 /></td>
              <td class="text-right"><number-format-component :input_value="Number(log_detail.total)" :decimal="2"/></td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
      mixins:[SwalMixin],
      components: {NumberFormatComponent},
      data: () => {
          return {
            form:{
              id:-1,
                payroll_type:'',
                project_id:'',
              date_from:'',
              date_to:'',
              voucher_number:'',
              check_number:'',
              remarks:'',
              payroll_details:[],
                cost_per_item:[],
              authorization:{
                username:'',
                password:''
              }
            },
            log_details:{},
            project:{},
            is_saving:false,
            modal:false,
            daily_logs_modal:false
          }
      },
      watch: {
        form:{
            immediate: true,
            deep:true,
            handler(){
              this.form.payroll_details.forEach((value, index) => {
                  value.total_payout = Number(value.initial_payout) - (Number(value.ca_payment) + Number(value.sss_payment) + Number(value.philhealth_payment) + Number(value.pagibig_payment) + Number(value.other_payment));
              });
            }
        }
      },
      computed: {
          total(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.total_payout);
              },0);
          },
          grand_initial_payout(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.initial_payout);
              },0);
          },
          grand_previous_ca_balance(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.previous_ca_balance);
              },0);
          },
          grand_ca_payment(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.ca_payment);
              },0);
          },
          grand_sss_payment(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.sss_payment);
              },0);
          },
          grand_philhealth_payment(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.philhealth_payment);
              },0);
          },
          grand_pagibig_payment(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.pagibig_payment);
              },0);
          },
          grand_other_payment(){
              return this.form.payroll_details.reduce((total, value)=>{
                  return total + Number(value.other_payment);
              },0);
          },
          payroll_dates(){
              console.log(this.form)

              let dates = [];

              if(
                  !this.form.date_from ||
                  !this.form.date_to
              ){
                  return dates;
              }

              let current = new Date(
                  this.form.date_from
              );

              let end = new Date(
                  this.form.date_to
              );

              while(current <= end){

                  dates.push(
                      current.toISOString().split('T')[0]
                  );

                  current.setDate(
                      current.getDate() + 1
                  );

              }

              return dates;

          },
      },
      created(){
        this.is_saving = true;
      this.form.payroll_type = this.$route.params.payroll_type;
      this.form.project_id = this.$route.params.project_id;
        this.form.date_from = this.$route.params.date_from;
        this.form.date_to = this.$route.params.date_to;

        let params={
            payroll_type:this.$route.params.payroll_type,
            project_id:this.$route.params.project_id,
              date_from:this.$route.params.date_from,
              date_to:this.$route.params.date_to
            }
        this.axios.get('payroll/generate',{params:params}).then(response => {
          let result = response.data;
          result.payroll_draft.forEach((value, index) => {
              let details = {
                manpower_id:value.id,
                full_name:value.last_name + ' ' + value.first_name,
                total_days:value.days_rendered,
                total_regular_hours:value.regular_hours,
                total_ot_hours:value.ot_hours,
                total_nd_hours:value.nd_hours,
                initial_payout:value.total,
                previous_ca_balance:value.ca_balance,
                logs:value.logs,
                ca_payment:0,
                sss_payment:0,
                philhealth_payment:0,
                pagibig_payment:0,
                other_payment:0,
                total_payout:value.total,
                remarks:''
              }
              this.form.payroll_details.push(details);
              this.form.cost_per_item = result.cost_per_item;
          });
          this.project = result.project;
          this.form.daily_log_ids = result.daily_log_ids;
          this.is_saving=false;
        }).catch(error => console.log(error));
      },
      methods: {
          formatDate(date){

              let d = new Date(date);

              let weekday = d.toLocaleDateString(
                  'en-US',
                  {
                      weekday:'short'
                  }
              ).toUpperCase();

              let day = String(d.getDate()).padStart(2, '0');

              let month = d.toLocaleDateString(
                  'en-US',
                  {
                      month:'short'
                  }
              ).toUpperCase();

              let year = String(d.getFullYear()).slice(-2);

              return `${weekday}\n${day}-${month}-${year}`;

          },
        showLogDetails(manpower_id){
          this.is_saving=true;
          let data = {
            manpower_id:manpower_id,
            payroll_type:this.$route.params.payroll_type,
            project_id:this.$route.params.project_id,
            date_from:this.$route.params.date_from,
            date_to:this.$route.params.date_to
          };
          this.axios.get('payroll/get_details',{params:data}).then(response => {
            //this.swalTransactionCompleted();
            this.is_saving=false;
            this.daily_logs_modal=true;
            this.log_details=response.data;
          }).catch(error => {
            this.swal_transaction_error_data.text = error.response.data;
            this.swalRequestError();
            this.is_saving=false;
          });
        },
        confirm(){
          if(this.form.payroll_details.length<=0){
            this.swal_transaction_error_data.text = "Nothing to process.";
            this.swalRequestError();
            return
          }
          this.modal=true;
        },
        save(){
          this.swalConfirmSubmit((data)=>{
            if (data.value) {
              this.is_saving=true;
              this.axios.post('payroll/save',this.form).then(response => {
                  this.swalTransactionCompleted();
                  this.is_saving=false;
                  this.$router.push('/manpowers/payroll/'+response.data.id);
              }).catch(error => {
                  this.swal_transaction_error_data.text = error.response.data;
                  this.swalRequestError();
                  this.is_saving=false;
              });
            }
          });
        },
          getLog(logs, date){

              console.log(date)
              console.log(logs)
              if(!logs){
                  return null;
              }
              console.log(date)
              console.log(logs)

              return logs.find(log => {

                  let logDate = new Date(
                      log.transaction_date_raw
                  )
                      .toISOString()
                      .split('T')[0];

                  return logDate === date;

              });

          }
      }
    }
</script>
<style>
    @media print {
        @page {
            size: landscape;
            margin: 10mm;
        }

        body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }

        /* Optional: make table fit better */
        table {
            width: 100%;
            font-size: 10px;
        }

        th, td {
            padding: 4px !important;
            white-space: nowrap;
        }

        /* Hide buttons, inputs, etc. when printing */
        button,
        .btn,
        input,
        .form-control {
            display: none !important;
        }
    }
</style>
